/**
 * 新版请求封装
 */
import { baseUrl as readwithUrl, gxHostUrl, hostUrl, isYzgx } from './env'
import { setCookie, getCookie, delCookie, userLogin } from './mUtils'
import { request as axios } from '@youshu/mono-sdk'

/**
 * axios请求二次封装
 * @param {object} params - 请求参数体
 * @param {string} params.type - 请求类型 取值 GET | POST | PUT | DELETE 等
 * @param {string} params.baseUrl - 请求地址公共前缀
 * @param {string} params.url - 请求接口地址
 * @param {object} [params.data] - 请求携带数据
 * @param {boolean} [params.shutLog] - 当前接口异常是否不上报xlog。true为不上报，false为上报。默认为false上报
 * @param {string} [params.apiProject] - 请求后台语言类型 取值 GO|PHP 。默认为GO
 * @returns `Promise<[null, object] | [object | undefined]>` 对象
 */

const request = async (type = 'GET', baseUrl = readwithUrl, url = '', data = {}, apiProject = 'PHP') => {
    try {
        // 类型转大写
        type = type.toUpperCase()
        if (!baseUrl) {
            baseUrl = readwithUrl
        }

        let headers = {
            // "Luban-Key": 'c3'
            // 'X-branch': 'PA-13219'
            'X-YS-DEVICE-ID': ''
        }
        if ((url.indexOf('/MobileLogin/checkCode') > -1 || url.indexOf('/Login/mobileLoginToCookie') > -1) && getCookie('PHPUniqueId')) {
            headers['PHPUniqueId'] = getCookie('PHPUniqueId') || ''
        }
        // 发起axios请求
        let responseJson = await axios({
            type,
            url: /^https?/.test(baseUrl) ? baseUrl : `${location.protocol}${baseUrl}`,
            uri: url,
            data,
            apiProject,
            timeout: 30000,
            headers
        })

        responseJson = responseJson ?? {}

        // 当请求体为Go时，将go的返回数据结构变成 {code: 1, data: {}, msg: ''} 类型
        if (apiProject === 'GO') {
            const { errno, errmsg, data } = responseJson.data
            responseJson.data = {
                code: Number(errno) === 0 ? 1 : errno,
                data,
                msg: errmsg
            }
        }

        // 登录
        const login_codes = [300, 3001, 3002, 3003, 4001, 4002, 1604, 10005]
        const is_login = login_codes.findIndex(function (item) {
            return item == responseJson.data.code
        })

        if (is_login != -1 && is_login != 6) {
            delCookie('HTTP_X_YS_UID')
            delCookie('HTTP_X_YS_USER_TOKEN')
            userLogin()
        } else if (is_login == 6) {
            // 未加入计划跳转到发现页
            if (isYzgx) { // 跳元知国学首页
                location.href = gxHostUrl + "/classroom_yz/yzgxStudy";
            } else {
                location.href = hostUrl + "/classroom_yz/study";
            }
        }

        return {...responseJson.data}
    } catch (error) {
        // Sentry.captureException(error)
        console.log('request catch err', error)
        return { code: 'NETWORK_ERROR', data: [], msg: '网络请求异常' }
    }
}

export default request
